import { render, staticRenderFns } from "./cSwitchBarObj.vue?vue&type=template&id=27c7c345&scoped=true"
import script from "./cSwitchBarObj.vue?vue&type=script&lang=js"
export * from "./cSwitchBarObj.vue?vue&type=script&lang=js"
import style0 from "./cSwitchBarObj.vue?vue&type=style&index=0&id=27c7c345&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c7c345",
  null
  
)

export default component.exports